import React, { ReactNode, useState } from 'react';
import { Tab } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { ClassNameMap, TabClassKey } from '@mui/material';

interface TabItem {
  label: string;
  content: ReactNode;
  testId?: string;
}
interface TabsPanelProps {
  tabsList: TabItem[];
  tabPanelClasses?: Partial<ClassNameMap<TabClassKey>>;
  tabPanelClassesGenerator?: (tabLabel: string) => Partial<ClassNameMap<TabClassKey>>;
}

export const TabsPanel = (props: TabsPanelProps) => {
  const { tabsList, tabPanelClasses, tabPanelClassesGenerator } = props;

  const [value, setValue] = useState('0');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <TabList onChange={handleChange} textColor="secondary">
        {tabsList.map(({ label, testId }, tabIndex) => (
          <Tab key={label} label={label} value={String(tabIndex)} data-testid={testId} />
        ))}
      </TabList>
      {tabsList.map(({ label, content }, tabIndex) => {
        const classes = tabPanelClassesGenerator
          ? tabPanelClassesGenerator(label)
          : tabPanelClasses ?? undefined;

        return (
          <TabPanel key={label} value={String(tabIndex)} classes={classes}>
            {content}
          </TabPanel>
        );
      })}
    </TabContext>
  );
};
